WL.registerComponent('synced-object', {
  colyseusObj: { type: WL.Type.Object },
  syncedObject: { type: WL.Type.String, default: '' },
  sendHeartbeat: { type: WL.Type.Bool, default: false }
}, {
  init: function () {
    this.isBody = false;
    if (this.syncedObject === 'body') {
      this.isBody = true;
    }
    
    this.prevTransform = new Float32Array(8);
    this.heartbeatPos = new Float32Array(8);
  },
  start: function () {
    this.colyseus = this.colyseusObj.getComponent('colyseus');
    if (this.sendHeartbeat) {
      setInterval(() => {
        // Check if any of our transform values have changed by more than 1
        if (this.prevTransform.some((el, idx) => Math.abs(el - this.heartbeatPos[idx]) > 1)) {
          this.colyseus.room.send(`heartbeat`);
          this.heartbeatPos = this.prevTransform.slice();
        }
      }, 5000);
    }
  },
  update: function (dt) {
    if (this.colyseus.room && this.syncedObject != null) {
      const pose = this.object.transformWorld;
      const positionWorld = this.object.getTranslationWorld([]) 
      if (JSON.stringify(this.prevTransform) === JSON.stringify(pose)) return;

      this.colyseus.room.send(`pose`, {
        object: this.syncedObject,
        pose: pose,
        positionWorld: positionWorld
      });

      this.prevTransform.set(pose);
    }
  }
});